// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.num[data-v-aa47c13e] {\n  font-size: 2em;\n}\n", ""]);
// Exports
module.exports = exports;
